// src/seo/jsonld.js
import { ExposedAPI } from "../apis/ExposedAPI";
import { SITE_URL } from "../config/site";

const clean = (value) => (value || "").replace(/\s+/g, " ").trim();

export function productJsonLd(a, canonicalPath, categoryLabel = "") {
  const name = clean(a.label);
  const category = clean(categoryLabel);
  const notes = clean(a.description);
  const description = notes || `${name}${category ? ` - ${category}` : ""}`;

  const mainPicture = (a.pictures || []).find((picture) => String(picture.firstAttachment) === "1")
    || (a.pictures || [])[0];
  const ld = {
    "@context": "https://schema.org",
    "@type": "Product",
    name,
    description,
    sku: a.crmId || String(a.id),
    url: `${SITE_URL}${canonicalPath}`,
    image: mainPicture
      ? ExposedAPI.getFullSizeAttachmentURL(mainPicture.id)
      : ExposedAPI.getThumbnailURL(a.id),
  };

  if (category) {
    ld.category = category;
  }

  const brandName = clean(a.brandName);
  if (brandName) {
    ld.brand = { "@type": "Brand", name: brandName };
  }

  const basePrice = Number(a.basePrice);
  if (a.basePrice != null && Number.isFinite(basePrice)) {
    const discount = Number(a.activeSaleCampaign?.percentage);
    const price = Number.isFinite(discount)
      ? basePrice * (1 - discount / 100)
      : basePrice;

    ld.offers = {
      "@type": "Offer",
      url: `${SITE_URL}${canonicalPath}`,
      priceCurrency: "EUR",
      price: price.toFixed(2),
      availability: "https://schema.org/InStock",
      seller: { "@type": "Organization", name: "Bio-Technofix" },
    };
  }

  return ld;
}

export function breadcrumbJsonLd(trail) {
  // trail = [{ name: 'Appareillage', path: '/categories/appareillage' }, …]
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Bio-Technofix",
  url: SITE_URL,
  logo: `${SITE_URL}/logo_btx_seo.svg`,
  telephone: "+33155581515",
  foundingDate: "1993",
  // À compléter dès que l'adresse est publiée sur le site
  address: {
    "@type": "PostalAddress",
    streetAddress: "5 rue Denis Papin, ZA de la Mare du Milieu – Lot C",
    postalCode: "91630",
    addressLocality: "Guibeville",
    addressCountry: "FR",
  },
};
